import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatTabChangeEvent, MatTabGroup } from "@angular/material/tabs";

import { DffCurrentRoute, DffRoute } from "@dffedb/router";
import { LocalStorage, trim } from "@dffedb/util";
import { HuskMigCredentialsService, LoginService } from "@e-forsyning/common/auth";
import { VaelgInstallationService } from "@e-forsyning/common/installation";
import { RedirectService } from "@e-forsyning/common/router";

import { LoginEmailComponent } from "./login-email/login-email.component";
import { LoginForbrugernrComponent } from "./login-forbrugernr/login-forbrugernr.component";
import { LoginFormBuilder } from "./login-form-builder";

@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
    public form: UntypedFormGroup;
    public loginFejl = false;
    public fejlBesked = "";
    @ViewChild(MatTabGroup, { static: true }) public tabGroup: MatTabGroup;
    @ViewChild(LoginEmailComponent, { static: true }) public loginEmailComponent: LoginEmailComponent;
    @ViewChild(LoginForbrugernrComponent, { static: true }) public loginForbrugernrComponent: LoginForbrugernrComponent;

    constructor(
        private readonly currentRoute: DffCurrentRoute,
        private readonly huskMigCredentialsService: HuskMigCredentialsService,
        private readonly redirectService: RedirectService,
        private readonly localStorage: LocalStorage,
        private readonly loginService: LoginService,
        private readonly vaelgInstallationService: VaelgInstallationService
    ) {}

    public ngOnInit(): void {
        this.loginService.logout();
        this.form = LoginFormBuilder.opretForm(this.huskMigCredentialsService);
        let index = parseInt(this.localStorage.getItem("login.index") || "", 10);
        if (!!this.form.get("huskMig").value) {
            index = this.form.get("forbrugerNrGroup.forbrugerNr").value === null ? 1 : 0;
        }
        this.tabGroup.selectedIndex = isNaN(index) ? 0 : index;
        setTimeout(() => this.focusTabContent(this.tabGroup.selectedIndex));
    }

    public async onLoginSucceeded(): Promise<void> {
        this.localStorage.setItem("login.index", this.tabGroup.selectedIndex.toString());
        await this.vaelgInstallationService.vaelgFoeresteInstallation(false);
        this.redirect();
    }

    public onNavigerTilOversigtClick(): void {
        this.redirectService.redirectTilVaerksListe();
    }

    public redirect(): void {
        const { path, params } = this.getRedirectPath();
        if (path && path !== "404") {
            this.redirectService.redirect(path, params);
        } else {
            this.redirectService.redirectTilDefault();
        }
    }

    public onForbrugerNrAlphaKeyPressed(value: string): void {
        // Man har forsøgt at taste et ikke-nummerisk tal i feltet Forbrugernumme.
        // Det betyder sandsynligvis at man forsøger at logge ind med mail-adresse (nim@softvaerket.dk) eller som FOF-bruger (SN).
        // I stedet for at der ikke sker noget, forsøger vi at hjælpe ved at skifte til fanen hvor man kan logge ind med e-mail.
        this.form.get("emailGroup.email").setValue(value);
        this.tabGroup.selectedIndex = 1;
    }

    public onSelectedTabChange(event: MatTabChangeEvent): void {
        this.focusTabContent(event.index);
    }

    private focusTabContent(tabIndex: number): void {
        if (tabIndex === 0) {
            this.loginForbrugernrComponent.focus();
        } else {
            this.loginEmailComponent.focus();
        }
    }

    private getRedirectPath(): DffRoute {
        // Fjern "login" fra url'en og returner resten.
        // Eksempel: /login/mine-oplysninger -> mine-oplysninger
        const { path, params } = this.currentRoute.value;
        const [_, ...rest] = trim(path, "/").split("/");
        return { params, path: rest.join("/") };
    }
}
